<template>
    <div
        class="modal trader-info acc-rej"
        id="trader-info"
        tabindex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
        
      >
        <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">BID ACCEPT OR REJECT</h5>
              <div class="float-right">
                    <button type="button" @click="getBids()" class="btn btn-sm btn-primary">
                        <span class="fas fa-sync-alt" aria-hidden="true"></span> REFRESH
                    </button>
                    <button type="button" class="close"  @click="closePopup()">
                        <span aria-hidden="true">&times;</span>
                    </button>
              </div>      
            </div>
            <div class="modal-body">
                <table class="table align-items-center table-flush table-hover bidtbl">
                    <thead class="thead-light psticky">
                    <tr>
                        <th 
                        scope="col" 
                        class="sort text-center"
                        >Bid Id</th>
                        <th 
                        scope="col" 
                        class="sort text-center"
                        >Cusip</th>
                        <th 
                        scope="col" 
                        class="sort text-center"
                        >QTY / <br> Min Qty</th>
                        <th 
                        scope="col" 
                        class="sort text-center"
                        >ECN</th>
                        <th 
                        scope="col" 
                        class="sort text-center"
                        >Bid <br> Price</th>
                        <th 
                        scope="col" 
                        class="sort text-center"
                        >Bid Ordered <br> Price</th>
                        <th 
                        scope="col" 
                        class=" text-center"
                        >Ordered <br> Quantity</th>
                        <th 
                        scope="col" 
                        class=" text-center"
                        >Action</th>
                    </tr>
                    </thead>  
                    <tbody class="">
                        <tr >
                            <td v-if="bids.length == 0 && !loader" colspan="5"><p class="nodata n">No data available</p>
                            </td>
                            <td v-if="loader">
                                <div class="loader"><img src="@/assets/img/loader.svg" alt=""/></div>
                            </td>
                        </tr>
                        <tr v-for="bid in bids" :key="bid.id">
                            <td class="text-center">{{bid.id}}</td>
                            <td class="text-center">{{bid.cusip}}</td>
                            <td class="text-center">{{bid.quantity}} / {{bid.minQuantity}}</td>
                            <td class="text-center">{{bid.ecn}}</td>
                            <td class="text-center">{{bid.amount}}</td>
                            <td class="text-center" v-bind:class="{'text-danger': bid.filledAmount != bid.amount }" >{{bid.filledAmount}}</td>
                            <td 
                                class="text-center"
                                v-bind:class="{'text-danger': checkMinMaxRangeExceed(bid.filledQuantity,bid.minQuantity,bid.quantity)}" >
                                {{bid.filledQuantity}}</td>
                            <td class="text-center"> 
                                <button type="button" @click="setBidAction('accept',bid)" class="btn btn-success">Accept</button>
                                <button type="button" @click="setBidAction('reject',bid)" class="btn btn-danger">Reject</button>
                                <!-- <button type="button" @click="clearBid(bid)" class="btn btn-info">Clear</button> -->
                            </td>
                        </tr>
                    
                    </tbody>
                </table> 
            </div>
          </div>
        </div>
    </div>      
</template>
<script>
import authService from "@/authService";
import config from "@/config";
export default {
    name: 'BidAcceptPopUp',
    data() {
        return {
            cognitoSub : null,
            bids:[],
            loader : false,
            isAdmin: false,
            isTrader : false,
            isEditor : false,
            isSuperAdmin : false,
            broadcastChannel : null

        };
    },
    methods : {
        closePopup(){
            this.broadcastChannel.postMessage({ message: 'close' });
            this.$emit('close');
        }, 

        setBidAction(action,bid){
            var message = "Are you sure you want to "+action+" this bid?";
            this.$confirm(message).then(() => {
                this.loader = true;
                const auth = {
                    headers: {'org-token' : authService.getOrgToken() }
                };
                this.$http
                .put(
                    config.baseUrlBidSide + '/bid/update-order-status',
                        {
                        "bidId": bid.bidId+"",
                        "bidAlertId": bid.id+"",
                        "status": action == 'accept' ? "ACCEPTED" : "REJECTED",
                        "cognitoSub" : this.cognitoSub
                        },
                    auth
                )
                .then(() => {
                    this.loader = false;
                    // get index of object with id
                    var removeIndex = this.bids.map(function(item) { return item.id; }).indexOf(bid.id);
                    // remove object
                    this.bids.splice(removeIndex, 1);
                    if(this.bids.length == 0){
                        // this.$emit('close');
                        this.closePopup();
                        this.$root.$emit("popupclosed");

                    }
                    this.broadcastChannel.postMessage({ message: 'action' });

                })
                .catch(() => {
                    this.loader = false;
                });
            });
            
        },
        clearBid(bid){
            var message = "Are you sure you want to clear this bid?";
            this.$confirm(message).then(() => {
                this.loader = true;
                const auth = {
                    headers: {'org-token' : authService.getOrgToken() }
                };
                this.$http
                .put(
                    config.baseUrlBidSide + '/bid-alerts/update',
                        {
                        "id": bid.id,
                        "status": "CLEAR"
                        },
                    auth
                )
                .then(() => {
                    this.loader = false;
                    // get index of object with id
                    var removeIndex = this.bids.map(function(item) { return item.id; }).indexOf(bid.id);
                    // remove object
                    this.bids.splice(removeIndex, 1);
                    if(this.bids.length == 0){
                        // this.$emit('close');
                        this.closePopup();
                        this.$root.$emit("popupclosed");

                    }
                    this.broadcastChannel.postMessage({ message: 'action' });

                })
                .catch(() => {
                    this.loader = false;
                });
            });
            
        },
        getBids(){
            this.loader = true;
            const auth = {
            headers: {'org-token' : authService.getOrgToken() }
            };
            var fDate = this.moment(this.moment().subtract(1,'days').format("YYYY-MM-DD")).utc().format("YYYY-MM-DD HH:mm:ss");
            var tDate = this.moment(this.moment().add(2,'days').format("YYYY-MM-DD")).utc().format("YYYY-MM-DD HH:mm:ss");
            var subId = (!this.isSuperAdmin && this.isTrader) ? this.cognitoSub : "";
            let url = ""
            if(subId){
                url = '/bid-alerts/list?status=UNREAD&cognitoSub='+this.cognitoSub;
            }else{
                url = '/bid-alerts/list?status=UNREAD';
            }
            //console.log("roles",this.isAdmin,this.isTrader)
            this.$http
            .get(
                config.baseUrlBidSide + url+
                "&fromDate="+
                fDate+
                "&toDate="+
                tDate,
                auth
            )
            .then(result => {
                result.data.content.forEach(element => {
                    if(element.ecn == 'IBP'){
                        element.ecn = "BondPoint"
                    }
                    if(element.ecn == 'TWD'){
                        element.ecn = "TradeWeb"
                    }
                });
            
                this.bids = result.data.content;
                this.loader = false;
                if(this.bids.length == 0){
                    this.$root.$emit("popupclosed");
                }
            })
            .catch(() => {
                this.loader = false;
            });
        },
        checkMinMaxRangeExceed(VALUE,MIN,MAX){
        if (VALUE >= MIN && VALUE <= MAX) { 
            return false;
        }
        else{
            return true;
        }
        },
        handleMessage(event) {
            // Handle incoming messages from other tabs
            if(event.data.message === "close"){
                this.$emit('close');
            }
            if(event.data.message === "action"){
                this.getBids();
            }
        },
  },
  created(){ 
    this.cognitoSub = authService.getUser().cognitoSub;
    this.$cognitoAuth.getUserGroup((err, role) => {
        if (err) {
          console.log("accessToken is not found", err);
        } else {
          this.tenantName = role[0].split("-")[0];
          var roleArray = role.map(item => {
            return  item.split("-")[1];
          })
          roleArray.includes('Admin')   ? this.isAdmin  = true : this.isAdmin  = false;
          roleArray.includes('Trader')  ? this.isTrader = true : this.isTrader = false;
          roleArray.includes('Editor')  ? this.isEditor = true : this.isEditor = false;
          roleArray.includes('SuperAdmin')  ? this.isSuperAdmin = true : this.isSuperAdmin = false;
        }
        this.getBids();
      });
    this.broadcastChannel = new BroadcastChannel('order-bid');
    this.broadcastChannel.addEventListener('message', this.handleMessage);
  },
  beforeDestroy() {
    this.broadcastChannel.close();
  }
  
};
</script>